/* ============================================================
   SO & RO — Custom JS — CRO Optimized
   ============================================================ */


/* ===== 1. CART DRAWER — Auto-open on add-to-cart ===== */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Ensure cart drawer opens automatically when item is added
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && !cartDrawer.hasAttribute('auto-open')) {
      cartDrawer.setAttribute('auto-open', 'true');
    }

    // Intercept add-to-cart form submissions to open drawer
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form) return;
      if (form.action && form.action.includes('/cart/add')) {
        setTimeout(function() {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else if (drawer && typeof drawer.showDialog === 'function') {
            drawer.showDialog();
          }
        }, 400);
      }
    });
  });
})();


/* ===== 2. STICKY ADD-TO-CART BAR — Mobile product pages ===== */
(function() {
  if (!window.location.pathname.includes('/products/')) return;
  if (window.innerWidth > 749) return;

  document.addEventListener('DOMContentLoaded', function() {
    var addToCartBtn = document.querySelector('button[name="add"], .product-form__submit, [data-block-type="add-to-cart"] button');
    if (!addToCartBtn) return;

    var stickyBar = document.createElement('div');
    stickyBar.id = 'soandro-sticky-atc';
    stickyBar.innerHTML = '<button id="soandro-sticky-atc-btn">In winkelwagen →</button>';
    stickyBar.style.cssText = 'position:fixed;bottom:0;left:0;right:0;z-index:9999;background:#fff;padding:10px 16px 18px;box-shadow:0 -2px 16px rgba(0,0,0,0.12);display:none;';
    document.body.appendChild(stickyBar);

    document.getElementById('soandro-sticky-atc-btn').style.cssText =
      'width:100%;padding:14px;background:#1a1a1a;color:#fff;border:none;font-size:0.9rem;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;border-radius:2px;cursor:pointer;';

    document.getElementById('soandro-sticky-atc-btn').addEventListener('click', function() {
      addToCartBtn.click();
    });

    // Show sticky bar when original button scrolls out of view
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.style.display = entry.isIntersecting ? 'none' : 'block';
      });
    }, { threshold: 0 });

    observer.observe(addToCartBtn);
  });
})();


/* ===== 3. REVIEW NUDGE — Post-purchase thank you page ===== */
(function() {
  if (!window.location.pathname.includes('/thank_you') &&
      !window.location.pathname.includes('/orders/')) return;

  var nudge = document.createElement('div');
  nudge.style.cssText = 'background:#fdf8ee;border:1px solid #c9a84c;padding:20px 24px;margin:20px 0;text-align:center;border-radius:4px;';
  nudge.innerHTML =
    '<p style="margin:0 0 8px;font-size:0.9rem;font-weight:600;color:#1a1a1a;">Bedankt voor je bestelling bij So &amp; Ro! 🎉</p>' +
    '<p style="margin:0 0 12px;font-size:0.82rem;color:#555;">Zou je een review willen achterlaten? Het helpt andere klanten enorm!</p>' +
    '<a href="https://www.soandro-shoesandmore.com" style="display:inline-block;padding:10px 20px;background:#1a1a1a;color:#fff;text-decoration:none;font-size:0.78rem;letter-spacing:0.08em;text-transform:uppercase;border-radius:2px;">Schrijf een review</a>';

  document.addEventListener('DOMContentLoaded', function() {
    var main = document.querySelector('main, .main-content, #main-content');
    if (main) main.insertAdjacentElement('afterbegin', nudge);
  });
})();


/* ===== 4. IMAGE LAZY LOADING — Apply to all product images ===== */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var imgs = document.querySelectorAll('img:not([loading])');
    imgs.forEach(function(img, i) {
      // First 3 images are likely above-fold — eager load them
      if (i < 3) {
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
      } else {
        img.setAttribute('loading', 'lazy');
      }
    });
  });
})();


/* ===== 5. PHYSICAL STORE TRUST BADGE — Product pages ===== */
(function() {
  if (!window.location.pathname.includes('/products/')) return;

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      var trustBar = document.querySelector('.soro-trust-bar');
      if (trustBar && !document.getElementById('soandro-store-badge')) {
        var storeBadge = document.createElement('div');
        storeBadge.id = 'soandro-store-badge';
        storeBadge.style.cssText = 'display:flex;align-items:center;gap:10px;padding:12px 0;border-top:1px solid #ebebeb;margin-top:4px;';
        storeBadge.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>' +
          '<div><span style="font-size:0.78rem;font-weight:600;letter-spacing:0.05em;color:#1a1a1a;text-transform:uppercase;display:block;">Ook te koop in onze winkel</span>' +
          '<span style="font-size:0.72rem;color:#777;letter-spacing:0.03em;">Bezoek ons in Venlo — persoonlijk advies</span></div>';
        trustBar.appendChild(storeBadge);
      }
    }, 600);
  });
})();

/* SOANDRO_SPANISH_UI_V1 */
(() => {
  if (!/^\/es(?:\/|$)/.test(window.location.pathname)) return;
  const ui = {
    'Home':'Inicio','Shop':'Tienda','About us':'Sobre nosotros','Contact':'Contacto',
    'Hakken':'Tacones','HAKKEN':'TACONES','Laarzen':'Botas','LAARZEN':'BOTAS','Chique Choices':'Selección elegante',
    'Festival Favorites':'Favoritos del festival','FESTIVAL FAVORITES':'FAVORITOS DEL FESTIVAL',
    'Cowboy Boots':'Botas cowboy','COWBOY BOOTS':'BOTAS COWBOY','Sale':'Rebajas','Verzenden':'Envío',
    'Retourneren':'Devoluciones','Winkel Eindhoven':'Tienda Eindhoven','Ons Verhaal':'Nuestra historia',
    'Privacybeleid':'Política de privacidad','Algemene Voorwaarden':'Términos y condiciones',
    'Cookiebeleid':'Política de cookies','Retourbeleid':'Política de devoluciones',
    'Shop New In ›':'VER NOVEDADES ›','SHOP NEW IN ›':'VER NOVEDADES ›',
    '@soandroshoesandmore op Instagram':'@soandroshoesandmore en Instagram',
    '@soandroshoesandmore op TikTok':'@soandroshoesandmore en TikTok',
    '✨ CHIQUE CHOICES — Hakken vanaf €29 | Geldig t/m 31 augustus':'✨ SELECCIÓN ELEGANTE — TACONES DESDE €29 | VÁLIDO HASTA EL 31 DE AGOSTO',
    '🥾 FESTIVAL FAVORITES — LAARZEN VANAF €45 | GELDIG T/M 31 AUGUSTUS':'🥾 FAVORITOS DEL FESTIVAL — BOTAS DESDE €45 | VÁLIDO HASTA EL 31 DE AGOSTO',
    '⭐ SALE STARS — 50% korting | Geldig t/m 31 augustus':'⭐ REBAJAS — 50% DE DESCUENTO | VÁLIDO HASTA EL 31 DE AGOSTO',
    '🎉 HEEL AUGUSTUS: GRATIS VERZENDING & GRATIS RETOUR — GEEN MINIMUMBEDRAG':'🎉 TODO AGOSTO: ENVÍO GRATIS Y DEVOLUCIÓN GRATIS — SIN IMPORTE MÍNIMO',
    'KLANTENSERVICE':'ATENCIÓN AL CLIENTE','OVER SO & RO':'SOBRE SO & RO','JURIDISCH':'LEGAL',
    'De Soof Familie':'La familia Soof','Nuestras botas signature':'Nuestras botas icónicas',
    'VOLG ONS OP INSTAGRAM':'SÍGUENOS EN INSTAGRAM','Lederlook':'Efecto piel',
    'Betaal achteraf met':'Paga después con','Gespreide betaling via':'Pago a plazos con','Betaal in 3 termijnen met':'Paga en 3 cuotas con'
  };
  const partial = {
    '4 beoordelingen':'4 opiniones','Geverifieerde koper':'Compra verificada',
    'GEVERIFIEERDE KOPER':'COMPRA VERIFICADA','Klant':'Cliente','KLANT':'CLIENTE'
  };
  function localize() {
    const nodes = [], walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const original = node.nodeValue;
      if (!original || !original.trim()) return;
      const leading = original.match(/^\s*/)[0], trailing = original.match(/\s*$/)[0];
      const exact = original.trim();
      if (Object.prototype.hasOwnProperty.call(ui, exact)) node.nodeValue = leading + ui[exact] + trailing;
      else {
        let next = original;
        Object.entries(partial).forEach(([from, to]) => { next = next.split(from).join(to); });
        if (next !== original) node.nodeValue = next;
      }
    });
  }
  let passes = 0;
  const timer = setInterval(() => { localize(); if (++passes === 50) clearInterval(timer); }, 200);
  document.addEventListener('DOMContentLoaded', localize);
})();
